export const singleChangeAction = (payload: any) => ({ type: 'SINGLE', payload: payload });
export const createAction = (type: string, payload: any) => ({ type, payload: payload });
